module.exports = __webpack_public_path__ + "img/product-placeholder-86.a84497b.png";